<mm-float-menu
  [headerColor]="'var(--secondary)'"
  [close-menu]="permContent?.closeMenu"
  [show]="true"
  (close)="close.emit(true)">
  <h5 class="text-white mb-0">Permissões</h5>
  <!-- O float-menu só projeta `ng-content` com `select="div"`; precisa ser um <div> nativo. -->
  <div>
    <mm-permission-menu-content
      #permContent
      [viewMode]="'sidebar'"
      [homepageId]="homepageId"
      [pageId]="pageId"
      [type]="type"
      [config]="config"
      [id]="id"
      [menu-id]="menuId"
      (updateList)="updateListEmitter.emit($event)">
    </mm-permission-menu-content>
  </div>
</mm-float-menu>
